export function areStringArraysEqual(a, b) {
    if (a.length !== b.length)
        return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, index) => val === sortedB[index]);
}
export function splitArray(arr, count) {
    return [arr.slice(0, count), arr.slice(count)];
}
